import React from 'react';
import {Route, Routes, Navigate} from "react-router-dom";

import Install from "./pages/Install";
import {RequireAuthentication} from "./Auth";
import LoginPage from "./pages/Authentication/LoginPage";
import PasswordResetPage from "./pages/Authentication/PasswordResetPage";
import PasswordChangePage from "./pages/Authentication/PasswordChangePage";
import UnlockAccountPage from "./pages/Authentication/UnlockAccountPage";

import MainLayout from "./layouts/Main";
import {Accommodations, Authentication, Bookings, Dashboard, FilterRules, Offers, Quotes, Settings, Rates} from "./pages";
import AllRules from "./pages/FilterRules/AllRules";
import FilteredRequests from "./pages/FilterRules/FilteredRequests";
import FormQuote from "./pages/Quotes/FormQuote";
import Quote from "./pages/Quotes/Quote";
import QuotePreview from "./pages/Quotes/Quote/QuotePreview";
import QuoteEmailViewer from "./pages/Quotes/Quote/QuoteEmailViewer";
import FeaturesNotifier from "./components/FeaturesNotifier";
import Booking from "./pages/Bookings/Booking";


function App() {
    return <Routes>
        <Route path="install" element={<Install/>}/>

        <Route path="auth" element={<Authentication/>}>
            <Route index element={<Navigate to="login" replace/>}/>
            <Route path="login" element={<LoginPage/>}/>
            <Route path="password-reset" element={<PasswordResetPage/>}/>
            <Route path="password-change" element={<PasswordChangePage/>}/>
            <Route path="unlock-account" element={<UnlockAccountPage/>}/>
            <Route path="*" element={<Navigate to="login" replace/>}/>
        </Route>

        <Route path="main" element={<RequireAuthentication><FeaturesNotifier><MainLayout/></FeaturesNotifier></RequireAuthentication>}>
            <Route index element={<Navigate to="dashboard" />} />

            <Route path="dashboard" element={<Dashboard/>}/>

            <Route path="filter_rules" element={<FilterRules/>}>
                <Route index element={<AllRules/>}/>
                <Route path="filter-rules/:ruleId/requests" element={<FilteredRequests/>}/>
                <Route path="*" element={<Navigate to="" replace />}/>
            </Route>

            <Route path="offers" element={<Offers/>}/>

            <Route path="bookings" element={<Bookings/>}>
                <Route path=":bookingId" element={<Booking/>}/>
                <Route path="*" element={<Navigate to="" replace/>}/>
            </Route>

            <Route path="rates" element={<Rates/>}>
                <Route path="*" element={<Navigate to="" replace/>}/>
            </Route>

            <Route path="quotes" element={<Quotes/>}>
                <Route path="new" element={<FormQuote/>}/>
                <Route path=":quoteId" element={<Quote/>}>
                    <Route path="preview" element={<QuotePreview/>}/>
                    <Route path="email" element={<QuoteEmailViewer/>}/>
                </Route>
                <Route path="*" element={<Navigate to="" replace/>}/>
            </Route>

            <Route path="homes" element={<Accommodations/>}/>

            <Route path="settings" element={<Settings/>}/>

            <Route path="*" element={<Navigate to="dashboard" />} />
        </Route>

        <Route path="*" element={<Navigate to="main" replace/>}/>
    </Routes>
}

export default App;